export type JsonLdHeadScript = {
  key: string;
  type: "application/ld+json";
  textContent: string;
};

export function serializeJsonLd(value: unknown): string {
  const serialized = JSON.stringify(value);
  if (serialized === undefined)
    throw new TypeError("JSON-LD value is not serializable");

  return serialized
    .replace(/&/g, "\\u0026")
    .replace(/</g, "\\u003c")
    .replace(/>/g, "\\u003e")
    .replace(/\u2028/g, "\\u2028")
    .replace(/\u2029/g, "\\u2029");
}

export function jsonLdHeadScript(
  key: string,
  value: unknown,
): JsonLdHeadScript {
  return {
    key,
    type: "application/ld+json",
    textContent: serializeJsonLd(value),
  };
}
